/**
 * Created by Ning Jiang on 2024-01-19.
 */

import {TimelineLite, TweenLite} from "gsap";
import {ElGordosRevengeSymbol} from "./ElGordosRevengeSymbol";
import {ElGordosRevengeSymbolState} from "./ElGordosRevengeSymbolConfig";
import {ElGordosRevengeSound} from "../sound/ElGordosRevengeSound";
import {ElGordosRevenge} from "../ElGordosRevenge";
import {ElGordosRevengeLayers, Layers} from "../view/ElGordosRevengeLayers";

export class EGRS1Symbol extends ElGordosRevengeSymbol {

    private _animationLevel:number = 0;

    constructor(reelId:number, initState:ElGordosRevengeSymbolState) {
        super("S1", reelId, initState);
    }

    public split(type:number, noWin:boolean):TimelineLite {
        return new TimelineLite();
    }

    protected getOnShotAnimationName():string {
        return `S1_Shoot`;
    }

    protected getDeadLoopAnimationName():string {
        return "S1DeadLoop";
    }

    protected getCharacterAssetName():string {
        return "S1";
    }

    public playAmountLanding(amount:number, playSound:boolean):TimelineLite {
        this.createDeadContainer();
        const aniName = `S1_Landing${Math.min(amount, 3)}`;
        const tl = new TimelineLite();
        if(playSound) {
            tl.add(() => {
                const volume = (this.reelId === 1 && (ElGordosRevenge.xBetController.selectedIndex === 1 || ElGordosRevenge.xBetController.selectedIndex === 2)) ? 0.5 : 1;
                ElGordosRevengeSound.playScatterLandSound(amount, this.reelId, volume);
            });
        }
        tl.add(() => {
            this._animationLevel = amount;
            this._deadCharacter.visible = true;
            this._deadCharacter.state.setAnimation(0, aniName, false);
        });
        tl.add(() => {
            // this._deadCharacter.state.setAnimation(0, aniName, false).trackTime = this._deadCharacter.spineData.findAnimation(aniName).duration;
        }, `+=${this._deadCharacter.spineData.findAnimation(aniName).duration}`);
        return tl;
    }

    public playAmountLandingLoop(amount:number):void {
        if(this._animationLevel > amount) {
            amount = this._animationLevel;
        }
        this.createDeadContainer();
        const aniName = amount < 4 ? `S1_Landing${amount}_Loop` : `S1_Landing3_Loop`;
        this._deadCharacter.visible = true;
        this._deadCharacter.state.setAnimation(0, aniName, true);
    }

    public playUpgrade():TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(() => {
            this._animationLevel = 4;
            this._deadCharacter.visible = true;
            this._deadCharacter.state.setAnimation(0, "M_Landing", false);
        });
        tl.add(() => {
            this._deadCharacter.state.setAnimation(0, "M_Loop", true);
        }, `+=${this._deadCharacter.spineData.findAnimation("M_Landing").duration}`);
        return tl;
    }

    public restoreUpgrade():void {
        this.createDeadContainer();
        this._animationLevel = 4;
        this._deadCharacter.visible = true;
        this._deadCharacter.state.setAnimation(0, "M_Loop", true);
    }

    public restoreS1():void {
        this._animationLevel = 3;
        this.playAmountLandingLoop(3);
    }

    protected playKill():TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(TweenLite.to(this, 0.2, {}));
        return tl;
    }

    // public playWin(isLanding:boolean):TimelineLite {
    //     this.createDeadContainer();
    //     const tl = new TimelineLite();
    //     tl.add(() => {
    //         this._deadCharacter.visible = true;
    //         const entry = this._deadCharacter.state.setAnimation(0, "win", false);
    //         entry.timeScale = 0.5;
    //     });
    //     tl.add(() => {
    //         this._deadCharacter.state.setAnimation(0, "win", false).time = this._deadCharacter.spineData.findAnimation("win").duration;
    //     }, `+=${this._deadCharacter.spineData.findAnimation("win").duration * 2}`);
    //
    //     if(isLanding) {
    //         const glow = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("S1"));
    //         glow.autoUpdate = true;
    //         glow.position.set(ElGordosRevengeReelView.REEL_AREAS[this.reelId].x, ElGordosRevengeReelView.REEL_AREAS[this.reelId].y + ElGordosRevengeSymbol.DEFAULT_HEIGHT * (ElGordosRevenge.model.parsedGameData.S1Positions[this.reelId] + 0.5));
    //         tl.add([
    //             () => {
    //                 ElGordosRevengeLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(glow);
    //                 glow.state.setAnimation(0, "S1Glow", false);
    //                 // DeadwoodRipBackground.shakeStageOnce(0.3);
    //             }
    //         ], 0);
    //         tl.add(() => {
    //             ElGordosRevengeLayers.getLayer(Layers.WIN_PRESENTATIONS)!.removeChild(glow);
    //             glow.state.setEmptyAnimations(0);
    //             glow.destroy();
    //         });
    //     }
    //     return tl;
    // }
    //
    // public playWinWRSLanding(playSound:boolean):TimelineLite {
    //     const tl = new TimelineLite();
    //     this.createDeadContainer();
    //     tl.add(() => {
    //         this._deadCharacter.visible = true;
    //         this._deadCharacter.state.setAnimation(0, "landing2", false);
    //         if(playSound) {
    //             // DeadwoodRipSound.playS1Land(2, this.reelId);
    //         }
    //     });
    //     tl.add(() => {
    //         this._deadCharacter.state.setAnimation(0, "landing2loop", true);
    //     }, `+=${this._deadCharacter.spineData.findAnimation("landing2").duration}`);
    //     return tl;
    // }

    public playWin():TimelineLite {
        const position = this.getGlobalCenterPosition();
        const s1Win = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("S1Win"));
        s1Win.autoUpdate = true;
        s1Win.position.set(position.x, position.y);
        const tl = new TimelineLite();
        tl.add([
            () => {
                ElGordosRevengeLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(s1Win);
                s1Win.state.setAnimation(0, "S1_Blast", false);
            },
            // this.playUpgrade()
        ]);
        tl.add(() => {
            s1Win.state.setEmptyAnimations(0);
            s1Win.parent.removeChild(s1Win);
            s1Win.destroy();
        }, s1Win.spineData.findAnimation("S1_Blast").duration);
        return tl;
    }

    protected playGunShotSound(stereoIndex:number):TimelineLite {
        return ElGordosRevengeSound.getDefaultGunShotBodyTimeline(stereoIndex);
    }

    protected playKillSound():void {
        ElGordosRevengeSound.playSymbolKill("S", this.reelId);
    }
}